module.exports = __webpack_public_path__ + "media/images/icons/hand-left-a7ff626031c7e363f7954dba3cc9694e.svg";